import React, { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  TextField,
  Typography,
  LinearProgress,
  Card,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DownloadIcon from "@mui/icons-material/Download";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import SearchBar from "../../components/SearchBar";
import { InputAdornment } from "@mui/material";
import { Dispatch, SetStateAction, useEffect } from "react";
import AiToggle from "../../components/aitoggle";
import InfoIcon from '@mui/icons-material/Info';

// 1. Sales & Revenue Report (Order Level)
export const salesData = [
  {
    orderId: "ORD-1001",
    orderDate: "2025-11-25",
    customerName: "Ali Khan",
    productName: "Wireless Mouse",
    sku: "WM-123",
    quantity: 2,
    unitPrice: 120,
    subtotal: 240,
    discount: 20,
    shippingFee: 15,
    vatAmount: 11,
    orderTotal: 246, // subtotal - discount + shipping + VAT
    commissionAmount: 24,
    vendorNetEarnings: 222,
    paymentMethod: "Credit Card",
    orderStatus: "Completed",
    payoutStatus: "Pending",
  },
  {
    orderId: "ORD-1002",
    orderDate: "2025-11-26",
    customerName: "Sara Al Farsi",
    productName: "Gaming Keyboard",
    sku: "GK-987",
    quantity: 1,
    unitPrice: 350,
    subtotal: 350,
    discount: 0,
    shippingFee: 20,
    vatAmount: 18.5,
    orderTotal: 388.5,
    commissionAmount: 35,
    vendorNetEarnings: 353.5,
    paymentMethod: "PayPal",
    orderStatus: "Completed",
    payoutStatus: "Paid",
  },
];

// 2. Commission Statement (Monthly)
export const commissionData = [
  {
    orderId: "ORD-1001",
    orderDate: "2025-11-25",
    productName: "Wireless Mouse",
    sku: "WM-123",
    totalSaleAmount: 246,
    commissionPercent: 10,
    commissionFee: 24.6,
    vatOnCommission: 1.23,
    netEarningsAfterCommission: 220.17,
    payoutCycle: "Nov 2025 Payout",
  },
  {
    orderId: "ORD-1002",
    orderDate: "2025-11-26",
    productName: "Gaming Keyboard",
    sku: "GK-987",
    totalSaleAmount: 388.5,
    commissionPercent: 9,
    commissionFee: 34.97,
    vatOnCommission: 1.75,
    netEarningsAfterCommission: 351.78,
    payoutCycle: "Nov 2025 Payout",
  },
];

// 3. VAT Summary
export const vatData = [
  {
    saleDate: "2025-11-25",
    orderId: "ORD-1001",
    taxableSales: 246,
    vatOnSales: 12.3,
    taxableRefunds: 0,
    vatAdjustments: 0,
    netVat: 12.3,
    period: "Nov 2025",
  },
  {
    saleDate: "2025-11-26",
    orderId: "ORD-1002",
    taxableSales: 388.5,
    vatOnSales: 19.43,
    taxableRefunds: 0,
    vatAdjustments: 0,
    netVat: 19.43,
    period: "Nov 2025",
  },
];

// 4. Refunds & Returns Report
export const refundsData = [
  {
    refundId: "RF-5001",
    orderId: "ORD-1001",
    refundDate: "2025-11-28",
    productName: "Wireless Mouse",
    sku: "WM-123",
    refundReason: "Damaged",
    refundAmount: 120,
    vatRefunded: 6,
    commissionReversal: 12,
    refundStatus: "Approved",
  },
  {
    refundId: "RF-5002",
    orderId: "ORD-1002",
    refundDate: "2025-11-29",
    productName: "Gaming Keyboard",
    sku: "GK-987",
    refundReason: "Wrong Item",
    refundAmount: 350,
    vatRefunded: 17.5,
    commissionReversal: 31.5,
    refundStatus: "Pending",
  },
];

const Finances = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);
  const [expanded, setExpanded] = useState<string | false>(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const handleAccordion =
    (panel: string) => (_event: any, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <>
      <div className="main_title">
        <h1>My Finances</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - My
          Finances
        </p>
      </div>

      {/* Sub Tabs */}
      <Box className="custom_tabs1">
        <Tabs
          value={tab}
          onChange={handleTabChange}
          aria-label="view product tabs"
          className="custom_tabs_links"
        >
          <Tab label="Earnings Overview" />
          <Tab label="Payouts" />
          <Tab label="Reports" />
          <Tab label="Financial AI Insights" />
        </Tabs>
      </Box>

      <div className="cards my_finance_page">
        {/* TAB 1 - Wallet Overview */}
        {tab === 0 && (
          <>
            <div className="stats_boxes gap_m">
              <div className="cards">
                <h2>AED 980</h2>
                <p>Pending Earnings</p>
              </div>
              <div className="cards">
                <h2>Nov 10 – AED 1,420</h2>
                <p>Upcoming Payout</p>
              </div>
              <div className="cards">
                <h2>AED 52,340</h2>
                <p>Lifetime Earnings</p>
              </div>
            </div>

            <Box
              sx={{
                background: "#e8f5e9",
                p: 2,
                mt: 3,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <ShowChartIcon color="success" />
              <Typography>
                <strong>Your sales increased 22% this week.</strong> Expect AED
                1,420 payout on Nov 10.
              </Typography>
            </Box>

            <div className="btn_flx mt_20">
              <Button className="btn btn_grey" startIcon={<DownloadIcon />}>
                Download Statement (PDF)
              </Button>
            </div>

            {/* <div className="chart_block mt_30">
              <Typography variant="h6">Weekly Earnings Progress</Typography>
              <LinearProgress
                variant="determinate"
                value={75}
                sx={{ height: 10, borderRadius: 5, mt: 1 }}
              />
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                75% progress toward next payout
              </Typography>
            </div> */}
          </>
        )}

        {/* TAB 2 - Payouts */}
        {tab === 1 && (
          <>
            <div className="table_header">
              <div className="left_s form">
                <TextField
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </div>
              <div className="right_s">
                <Button className="btn btn_primary"> Export CSV</Button>
              </div>
            </div>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Payout ID</TableCell>
                    <TableCell>Amount (AED)</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Receipt</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[
                    {
                      id: "P-1021",
                      date: "Nov 5",
                      amount: 1420,
                      orders: 12,
                      status: "Completed",
                    },
                    {
                      id: "P-1020",
                      date: "Oct 28",
                      amount: 1370,
                      orders: 9,
                      status: "Processing",
                    },
                    {
                      id: "P-1019",
                      date: "Oct 21",
                      amount: 1290,
                      orders: 10,
                      status: "Failed",
                    },
                  ].map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell>{row.date}</TableCell>
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.amount}</TableCell>
                      <TableCell>
                        {row.status === "Completed" && (
                          <Chip label="🟢 Completed" color="success" />
                        )}
                        {row.status === "Processing" && (
                          <Chip label="🟡 Processing" color="warning" />
                        )}
                        {row.status === "Failed" && (
                          <Chip label="🔴 Failed" color="error" />
                        )}
                      </TableCell>
                      <TableCell>
                        <Button
                          className="btn btn_grey sm"
                          startIcon={<DownloadIcon />}
                        >
                          Receipt
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <div className="ai_banner mt_20">
              <p>
                Your last 3 payouts were on time. Average payout processing:{" "}
                <b>1.8 days</b>. <br />
                💡 Next payout expected: <b>AED 2,370</b> on Tue, Nov 11.
              </p>
            </div>
          </>
        )}

        {/* TAB 3 - AI Insights & Financial Reports */}
        {tab === 2 && (
          <>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              AI Insights & Financial Reports
            </Typography>

            <Box sx={{ mt: 3 }}>
              {/* 1. Sales & Revenue Report */}
              <Accordion
                expanded={expanded === "sales"}
                onChange={handleAccordion("sales")}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: 600 }}>
                    Sales & Revenue Report
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Card sx={{ p: 2 }}>
                    <div className="table_header">
                      <div className="left_s form">
                        <TextField
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          size="small"
                        />
                      </div>
                      <div className="right_s">
                        <Button className="btn btn_primary">Export CSV</Button>
                      </div>
                    </div>
                    <TableContainer className="table_container">
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Order ID</TableCell>
                            <TableCell>Order Date</TableCell>
                            <TableCell>Customer Name</TableCell>
                            <TableCell>Product Name</TableCell>
                            <TableCell>SKU / Variant</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Unit Price (AED)</TableCell>
                            <TableCell>Subtotal</TableCell>
                            <TableCell>Discount Applied</TableCell>
                            <TableCell>Shipping Fee</TableCell>
                            <TableCell>VAT Amount</TableCell>
                            <TableCell>Order Total</TableCell>
                            <TableCell>Commission Amount</TableCell>
                            <TableCell>Vendor Net Earnings</TableCell>
                            <TableCell>Payment Method</TableCell>
                            <TableCell>Order Status</TableCell>
                            <TableCell>Payout Status</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {salesData.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.orderId}</TableCell>
                              <TableCell>{row.orderDate}</TableCell>
                              <TableCell>{row.customerName}</TableCell>
                              <TableCell>{row.productName}</TableCell>
                              <TableCell>{row.sku}</TableCell>
                              <TableCell>{row.quantity}</TableCell>
                              <TableCell>{row.unitPrice}</TableCell>
                              <TableCell>{row.subtotal}</TableCell>
                              <TableCell>{row.discount}</TableCell>
                              <TableCell>{row.shippingFee}</TableCell>
                              <TableCell>{row.vatAmount}</TableCell>
                              <TableCell>{row.orderTotal}</TableCell>
                              <TableCell>{row.commissionAmount}</TableCell>
                              <TableCell>{row.vendorNetEarnings}</TableCell>
                              <TableCell>{row.paymentMethod}</TableCell>
                              <TableCell>{row.orderStatus}</TableCell>
                              <TableCell>{row.payoutStatus}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </AccordionDetails>
              </Accordion>

              {/* 2. Commission Statement */}
              <Accordion
                expanded={expanded === "commission"}
                onChange={handleAccordion("commission")}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: 600 }}>
                    Commission Statement
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Card sx={{ p: 2 }}>
                    <div className="table_header">
                      <div className="left_s form">
                        <TextField
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          size="small"
                        />
                      </div>
                      <div className="right_s">
                        <Button className="btn btn_primary">Export CSV</Button>
                      </div>
                    </div>
                    <TableContainer className="table_container">
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Order ID</TableCell>
                            <TableCell>Order Date</TableCell>
                            <TableCell>Product Name</TableCell>
                            <TableCell>SKU / Variant</TableCell>
                            <TableCell>Total Sale Amount</TableCell>
                            <TableCell>Commission %</TableCell>
                            <TableCell>Commission Fee (AED)</TableCell>
                            <TableCell>VAT on Commission</TableCell>
                            <TableCell>Net Earnings After Commission</TableCell>
                            <TableCell>Payout Cycle</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {commissionData.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.orderId}</TableCell>
                              <TableCell>{row.orderDate}</TableCell>
                              <TableCell>{row.productName}</TableCell>
                              <TableCell>{row.sku}</TableCell>
                              <TableCell>{row.totalSaleAmount}</TableCell>
                              <TableCell>{row.commissionPercent}</TableCell>
                              <TableCell>{row.commissionFee}</TableCell>
                              <TableCell>{row.vatOnCommission}</TableCell>
                              <TableCell>
                                {row.netEarningsAfterCommission}
                              </TableCell>
                              <TableCell>{row.payoutCycle}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </AccordionDetails>
              </Accordion>

              {/* 3. VAT Summary */}
              <Accordion
                expanded={expanded === "vat"}
                onChange={handleAccordion("vat")}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: 600 }}>
                    VAT Summary (UAE FTA Compliant)
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Card sx={{ p: 2 }}>
                    <div className="table_header">
                      <div className="left_s form">
                        <TextField
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          size="small"
                        />
                      </div>
                      <div className="right_s">
                        <Button className="btn btn_primary">Export CSV</Button>
                      </div>
                    </div>
                    <TableContainer className="table_container">
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Sale Date</TableCell>
                            <TableCell>Order ID</TableCell>
                            <TableCell>Taxable Amount (Sales)</TableCell>
                            <TableCell>VAT on Sales (5%)</TableCell>
                            <TableCell>Taxable Amount from Refunds</TableCell>
                            <TableCell>VAT Adjustments on Refunds</TableCell>
                            <TableCell>Net VAT Payable / Claimable</TableCell>
                            <TableCell>Period</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {vatData.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.saleDate}</TableCell>
                              <TableCell>{row.orderId}</TableCell>
                              <TableCell>{row.taxableSales}</TableCell>
                              <TableCell>{row.vatOnSales}</TableCell>
                              <TableCell>{row.taxableRefunds}</TableCell>
                              <TableCell>{row.vatAdjustments}</TableCell>
                              <TableCell>{row.netVat}</TableCell>
                              <TableCell>{row.period}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </AccordionDetails>
              </Accordion>

              {/* 4. Refunds & Returns Report */}
              <Accordion
                expanded={expanded === "refunds"}
                onChange={handleAccordion("refunds")}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: 600 }}>
                    Refunds & Returns Report
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Card sx={{ p: 2 }}>
                    <div className="table_header">
                      <div className="left_s form">
                        <TextField
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          size="small"
                        />
                      </div>
                      <div className="right_s">
                        <Button className="btn btn_primary">Export CSV</Button>
                      </div>
                    </div>
                    <TableContainer className="table_container">
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Refund ID</TableCell>
                            <TableCell>Order ID</TableCell>
                            <TableCell>Refund Date</TableCell>
                            <TableCell>Product Name</TableCell>
                            <TableCell>SKU / Variant</TableCell>
                            <TableCell>Refund Reason</TableCell>
                            <TableCell>Refund Amount</TableCell>
                            <TableCell>VAT Refunded</TableCell>
                            <TableCell>Commission Reversal</TableCell>
                            <TableCell>Refund Status</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {refundsData.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.refundId}</TableCell>
                              <TableCell>{row.orderId}</TableCell>
                              <TableCell>{row.refundDate}</TableCell>
                              <TableCell>{row.productName}</TableCell>
                              <TableCell>{row.sku}</TableCell>
                              <TableCell>{row.refundReason}</TableCell>
                              <TableCell>{row.refundAmount}</TableCell>
                              <TableCell>{row.vatRefunded}</TableCell>
                              <TableCell>{row.commissionReversal}</TableCell>
                              <TableCell>{row.refundStatus}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </AccordionDetails>
              </Accordion>

            </Box>
          </>
        )}
        {tab === 3 && (
          <>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              Financial AI Chat insight
            </Typography>

            <div className="table_header">
              <div className="left_s">
                <Box className="form search_bar ai_search filled">
                  <TextField

                    hiddenLabel
                    placeholder="Search here"
                    className="txt_inpt"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="search_icon">
                          <img src="/static/images/searchbar_icon.svg" alt="Icon" />
                        </InputAdornment>
                      ),

                    }}
                  />
                  <AiToggle />
                </Box>
                <Tooltip placement="top" title="100/150 queries used.For more reference navigate to My Subscription and AI tokens tab under Settings module">
                  <IconButton>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>


              </div>
            </div>
            <Box className="ai-upgrade-wrapper">
              <Typography variant="h6" className="title">
                Upgrade AI Query Limits
              </Typography>

              <Typography className="subtitle">
                To increase your monthly limit, purchase an additional package or
                upgrade your subscription.
              </Typography>

              <div className="cards">
                {/* LEFT CARD */}
                <div className="card">
                  <h4 className="card-title">✨ Additional Packages</h4>

                  <ul className="package-list">
                    <li>50 extra queries · <span>AED 59</span></li>
                    <li>100 extra queries · <span>AED 99</span></li>
                    <li>200 extra queries · <span>AED 149</span></li>
                  </ul>

                  <Button className="btn btn_primary">
                    Buy Package
                  </Button>
                </div>

                {/* RIGHT CARD */}
                <div className="card">
                  <h4 className="card-title">⬆ Upgrade Subscription</h4>

                  <p className="text">
                    Get more queries with the Grow, Scale, or Pro plans.
                  </p>

                  <Button variant="outlined" className="view-btn">
                    View Plans
                  </Button>
                </div>
              </div>
            </Box>
            <Box sx={{ p: 2, backgroundColor: "#f9f7e8", borderRadius: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Top product by margin
              </Typography>
              <Typography>
                <strong>Traditional Handbag</strong> · 32,5 % (2,2 AKD lifetime
                value)
              </Typography>

              <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
                Cash flow forecast
              </Typography>
              <Typography>+ 5,9 k AED · predicted next 30 days</Typography>

              <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
                Refund risk prediction
              </Typography>
              <Typography>
                Silk Scarf · High return rate <em>hagsh:</em> 5,2 %
              </Typography>

              <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
                Estimated net profit
              </Typography>
              <Typography>
                58,9 k AED · Last 30 days → profit margin: 27,4 %
              </Typography>
            </Box>
          </>
        )}
      </div>
    </>
  );
};

export default Finances;
